import { CustomState, OrderHistoryLogEntry, OrderSearchHit, StoreGroup, ShopperInsightsSearchHitCheckout, ShopperInsightsSearchHitSession } from "lib/types/generated/graphql-types"
import esb from "elastic-builder"
import { store } from "lib/store"
import { setCustomerEmail, setCustomerOrders, setCustomerCheckouts, setCustomerSessions, clearCustomerData } from "lib/store/services/customer/customerSlice"

export class CustomerOrders {
  private readonly customStates
  private readonly storeGroups

  constructor(customStates: CustomState[], storeGroups: StoreGroup[]) {
    this.customStates = customStates
    this.storeGroups = storeGroups
  }

  public setEmail(email: string | undefined) {
    const dispatch = store.dispatch
    dispatch(setCustomerEmail(email))
  }

  public setOrders(orders: OrderSearchHit[] | undefined) {
    const dispatch = store.dispatch
    dispatch(setCustomerOrders(orders))
  }

  public setCheckouts(checkouts: ShopperInsightsSearchHitCheckout[]) {
    const dispatch = store.dispatch
    dispatch(setCustomerCheckouts(checkouts))
  }

  public setSessions(sessions: ShopperInsightsSearchHitSession[]) {
    const dispatch = store.dispatch
    dispatch(setCustomerSessions(sessions))
  }

  public clearAll() {
    const dispatch = store.dispatch
    dispatch(clearCustomerData())
  }

  public getBlockingOperations(appliedStates: string[]): (string | null | undefined)[] {
    const blockedOperations =
      this.customStates
        .filter((state) => appliedStates.includes(state.id))
        ?.flatMap((state) => state.operations)
        .filter((state) => !!state) ?? []
    return blockedOperations ? [...new Set(blockedOperations)] : []
  }

  public getStoreGroupName(storeGroupId: string): string | undefined {
    return this.storeGroups.find((sg) => sg.id === storeGroupId)?.name
  }

  public getFilteredOrderLogEntries(
    entries: OrderHistoryLogEntry[],
    appliedStates: string[]
  ): OrderHistoryLogEntry[] {
    return entries
      ?.filter(
        (entry: OrderHistoryLogEntry) =>
          entry.type === "ADD_COMMENT" ||
          (entry.type === "ADD_CUSTOM_STATE" && appliedStates.includes(entry.operationId))
      )
      ?.reverse()
  }

  public getCustomState(stateId: string): CustomState | undefined {
    return this.customStates.find((state) => state.id === stateId)
  }

  public getSearchVariables(email: string) {
    return {
      variables: {
        from: 0,
        size: 1000,
        sort: [{ field: "date", order: "DESC" }],
        query: JSON.stringify(
          esb.boolQuery().must(esb.matchQuery("billingAddress.email", email))?.toJSON()
        )
      }
    }
  }
}
